<template>
  <nav
    class="navbar is-transparent is-fixed-top"
    role="navigation"
    aria-label="main navigation"
  >
    <div
      class="navbar-brand height70px"
      v-bind:class="{
        'is-active': isOpen,
        'color-background-burger': isOpen
      }"
    >
      <a
        role="button"
        class="navbar-burger border-burger burger-corner "
        aria-label="menu"
        aria-expanded="false"
        @click="isOpen = !isOpen"
        v-bind:class="{
          'is-active': isOpen,
          'orange-color': this.activeSection >= 2
        }"
      >
        <span
          class="top-span-style border-burger-span "
          aria-hidden="true"
          v-bind:class="{
            'orange-color': this.activeSection >= 2
          }"
        ></span>
        <span
          class="middle-span-style border-burger-span "
          aria-hidden="true"
          v-bind:class="{
            'orange-color': this.activeSection >= 2
          }"
        ></span>
        <span
          class="border-burger-span bottom-span-style"
          aria-hidden="true"
          v-bind:class="{
            'orange-color': this.activeSection >= 2
          }"
        ></span>
      </a>
    </div>

    <div
      class="navbar-menu transparent-touch top30"
      v-bind:class="{
        'is-active': isOpen,
        'color-background-burger': activeSection !== 0,
        'transparen-overlay': activeSection === 0
      }"
      @click="isOpen = !isOpen"
    >
      <div class="navbar-start center-navbar">
        <div class="column is-1-desktop is-paddingless width4">
          <div
            class="column is-1-desktop no-horizontal-padding no-top-padding"
          ></div>
          <img
            class="opti-image is-hidden-mobile"
            :src="getImg('common/Logo-Calce-superior.png')"
            alt
          />
        </div>
        <NavbarLink
          text="Inicio"
          target="section-welcome"
          :active="this.activeSection === 0"
        />
        <NavbarLink
          text="¿Qué es una funda cosmética?"
          target="section-qeuf"
          :active="this.activeSection === 1"
        />
        <NavbarLink
          text="Fabricación"
          target="section-fabricacion"
          :active="this.activeSection === 2"
        />
        <NavbarLink
          text="Testimonios"
          target="section-testimonios"
          :active="this.activeSection === 3"
        />
        <NavbarLink
          text="Contacto"
          target="section-contacto"
          :active="this.activeSection === 4"
        />
      </div>
      <div class="navbar-end is-hidden"></div>
    </div>
  </nav>
</template>

<script>
import NavbarLink from '@/components/NavbarLink'
import { getImg } from '@/utils/assets-helpers'

export default {
  name: 'Navbar',
  components: {
    NavbarLink
  },
  props: {
    activeSection: Number
  },
  methods: {
    getImg
  },
  data: function() {
    return {
      isOpen: false
    }
  }
}
</script>

<style>
nav.transparent-overlay {
  background: rgba(255, 255, 255, 0) !important;
}

div.transparent-overlay {
  background-color: rgba(255, 255, 255, 0) !important;
}
.is-transparent {
  background: rgba(255, 255, 255, 0);
}
@media screen and (max-width: 1087px) {
  .transparent-touch {
    background: rgba(0, 0, 0, 0.8) !important;
  }
}

.color-background-burger {
  background: rgba(0, 0, 0, 0.8);
}

.center-navbar {
  flex-grow: 1;
  justify-content: center;
}

.border-burger {
  border: 5px solid;
  color: white;
}

.border-burger-span {
  border: solid;
  color: white;
}
a:hover {
  color: white;
}

.navbar-burger.is-active span:nth-child(1) {
  transform: translateY(10px) rotate(45deg);
}

.navbar-burger.is-active span:nth-child(3) {
  transform: translateY(-11px) rotate(-45deg);
}

.burger-corner {
  right: 18px;
  top: 18px;
  margin-bottom: 10px;
}

.top-span-style {
  top: 8px !important;
  left: 7px !important;
  width: 29px !important;
}

.middle-span-style {
  top: 18px !important;
  left: 7px !important;
  width: 29px !important;
}

.bottom-span-style {
  top: 29px !important;
  left: 7px !important;
  width: 29px !important;
}

.opti-image {
  width: 3vw;
  height: auto;
  padding-bottom: 0;
  margin-bottom: 5px;
}
.no-top-padding {
  padding-top: 0 !important;
}

.width4 {
  width: 4vw !important;
}

.height70px {
  height: 70px;
}

.top30 {
  top: 30vh;
}

.orange-color {
  color: #f39e52 !important;
}
</style>
